export default "__VITE_ASSET__ux6dbbBs__"